import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { PaymentMethodModel } from '../../../../customer/customer.model';

@Component({
  selector: 'app-nacha-ach-token-selector-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatIconModule, MatRadioModule],
  templateUrl: './ach-token-selector-modal.component.html',
})
export class NachaAchTokenSelectorModalComponent implements OnInit {
  @Input() data: any;

  selectedToken: PaymentMethodModel | null = null;

  get achTokens(): PaymentMethodModel[] {
    return this.data?.data?.achTokens ?? [];
  }

  get customerName(): string {
    return this.data?.data?.match?.customer?.displayName
      ?? this.data?.data?.match?.customer?.companyName
      ?? 'Customer';
  }

  ngOnInit(): void {
    // Pre-select the default token if available
    const defaultToken = this.achTokens.find((t) => t.isDefault);
    this.selectedToken = defaultToken ?? this.achTokens[0] ?? null;
  }

  maskAccount(account?: string): string {
    if (!account) return '****';
    return '*'.repeat(Math.max(0, account.length - 4)) + account.slice(-4);
  }

  isValidSelection(): boolean {
    return this.selectedToken !== null;
  }
}
